<template>
    <div>
        <v-form autocomplete="off" v-model="valid" v-if="primaryNews && additionalNewsList && !previewNews" class="editor-form">
            <v-card>
                <v-layout class="news-feed-editor relative-position" row wrap v-if="!showImageGuidelines">
                    <div class="disabled-overlay" v-if="saveInProgress"></div>
                    <v-flex xs12 sm7 class="news-feed-editor__main" pa-3>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                        height="26"
                                        v-model="primaryNews.title"
                                        :label="newsFeedConstant.label.HERO_HEADLINE"
                                        data-qe-id="hero-news_headline"
                                        :rules="[rules.maxHeadlineChar]"
                                        :counter="newsFeedConstant.const.maxHeadlineChar"
                                        :maxlength="newsFeedConstant.const.maxHeadlineChar">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 pt-2>
                                <v-text-field
                                        height="26"
                                        :label="newsFeedConstant.label.HERO_BODY"
                                        data-qe-id="hero-news_body"
                                        v-model="primaryNews.body"
                                        :rules="[rules.maxBodyChar]"
                                        :counter="newsFeedConstant.const.maxBodyChar"
                                        :maxlength="newsFeedConstant.const.maxBodyChar">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 pb-2 pt-2>
                                <v-text-field
                                        :rules="[primaryNews.url ? rules.validUrl : rules.urlRequired]"
                                        height="26"
                                        :label="newsFeedConstant.label.HERO_URL_LINK"
                                        v-model="primaryNews.url"
                                        data-qe-id="hero-news_url">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 pt-3>
                                <v-checkbox color="primary"
                                            class="news-feed-editor__checkbox"
                                            hide-details
                                            data-qe-id="hero-news_show-btn"
                                            v-model="primaryNews.showButton"
                                            :label="newsFeedConstant.label.SHOW_BUTTON">
                                </v-checkbox>
                            </v-flex>
                            <v-flex xs12 pt-3>
                                <v-text-field
                                        height="26"
                                        :label="newsFeedConstant.label.HERO_BUTTON_TEXT"
                                        :disabled="!primaryNews.showButton"
                                        data-qe-id="hero-news_show-btn_text"
                                        :rules="[primaryNews.showButton ? rules.showButton : true, rules.maxButtonChar]"
                                        v-model="primaryNews.buttonText"
                                        :counter="newsFeedConstant.const.maxButtonChar"
                                        :maxlength="newsFeedConstant.const.maxButtonChar">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 pt-4>
                                <v-layout row wrap>
                                    <v-flex xs12 sm7 class="news-feed-editor__main-image--wrapper">
                                        <v-img v-if="primaryNews.featuredNewsImage && primaryNews.featuredNewsImage.url"
                                             class="news-feed-editor__main-image"
                                             :alt="newsFeedConstant.label.IMAGE_NOT_LOADED"
                                             data-qe-id="hero-news_image"
                                               :src="primaryNews.featuredNewsImage.url"></v-img>
                                    </v-flex>
                                    <v-flex xs12 sm5 class="relative-position text-right">
                                        <v-checkbox color="primary"
                                                    class="news-feed-editor__checkbox news-feed-editor__main-image--checkbox"
                                                    hide-details
                                                    data-qe-id="hero-news_dark-theme"
                                                    v-model="primaryNews.isDarkTheme"
                                                    :label="newsFeedConstant.label.DARKEN_IMAGE">
                                        </v-checkbox>
                                    </v-flex>
                                    <v-flex xs12 pa-1 v-if="imageTypeError" class="error-color">
                                        {{imageTypeError}}
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 pt-3>
                                <file-upload
                                        class="create-feature-event__file-upload secondary_btn"
                                        extensions="jpg,jpeg,png"
                                        accept="image/png, image/jpg, image/jpeg"
                                        color="info"
                                        post-action="/upload/post"
                                        data-qe-id="hero-news_upload-img_btn"
                                        v-model="files"
                                        @input="updateUploadedFile"
                                        @input-filter="inputFilterForImageFile"
                                        ref="upload">
                                    <span class="news-feed-editor__upload-image">{{newsFeedConstant.label.UPDATE_IMAGE}}</span>
                                </file-upload>
                            </v-flex>
                        </v-layout>
                        <v-layout pt-1>
                            <v-flex xs12
                                    data-qe-id="hero-news_guideline"
                                    @click="toggleShowImageGuidelines"
                                    class="news-feed-editor__guidelines">
                                {{newsFeedConstant.label.IMAGE_GUIDELINE}}
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm5 class="news-feed-editor__additional">
                        <v-layout pl-3 pr-3 pt-3 pb-2
                                  class="additional-news"
                                  v-for="(news, index) in additionalNewsList"
                                  :key="news.id"
                                  column>
                            <v-flex xs12>
                                <v-text-field
                                        height="26"
                                        :data-qe-id="`additional-news_${index}_headline`"
                                        v-model="news.title"
                                        :rules="[rules.headlineRequired, rules.maxHeadlineChar]"
                                        :label="additionalHeadline(index+2)"
                                        :counter="newsFeedConstant.const.maxHeadlineChar"
                                        :maxlength="newsFeedConstant.const.maxHeadlineChar">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 pt-2>
                                <v-text-field
                                        height="26"
                                        :data-qe-id="`additional-news_${index}_urlText`"
                                        :rules="[rules.urlTextRequired, rules.maxUrlTextChar]"
                                        :label="additionalLinkText(index+2)"
                                        v-model="news.urltext"
                                        :counter="newsFeedConstant.const.maxUrlTextChar"
                                        :maxlength="newsFeedConstant.const.maxUrlTextChar">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 pb-2>
                                <v-btn-toggle v-model="news.activeLinkType"
                                              mandatory
                                              class="additional-news__type">
                                    <v-btn flat value="url" :data-qe-id="`additional-news_${index}_type-Url`">
                                        {{newsFeedConstant.label.URL_BTN}}
                                    </v-btn>
                                    <v-btn flat value="email"
                                           :data-qe-id="`additional-news_${index}_type-email`"
                                           class="additional-news__type--email">
                                        {{newsFeedConstant.label.EMAIL_BTN}}
                                    </v-btn>
                                </v-btn-toggle>
                            </v-flex>
                            <v-flex xs12 pt-2>
                                <v-text-field
                                        v-if="news.activeLinkType && news.activeLinkType === 'url'"
                                        height="26"
                                        v-model="news.url"
                                        :rules="[news.url ? rules.validUrl : rules.urlRequired]"
                                        :label="additionalUrl(index+2, news.activeLinkType)"
                                        :data-qe-id="`additional-news_${index}_url`">
                                </v-text-field>
                                <v-text-field
                                        v-else
                                        height="26"
                                        v-model="news.emailUrl"
                                        :rules="[news.emailUrl ? rules.validEmail : rules.emailRequired]"
                                        :label="additionalUrl(index+2, news.activeLinkType)"
                                        :data-qe-id="`additional-news_${index}_email-url`">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pt-1 pb-2 v-if="!showImageGuidelines">
                    <v-flex xs12><status-bar :action="updateNewsAction"></status-bar></v-flex>
                    <v-flex xs12 sm5 class="news-feed-editor__required-msg">
                        {{newsFeedConstant.label.REQUIRED_TO_SAVE}}
                    </v-flex>
                    <v-flex xs12 sm7 class="text-right">
                        <v-btn flat
                               small
                               id="cancel_news_edit"
                               class="bold-font"
                               data-qe-id="cancel_news_edit_btn"
                               :disabled="saveInProgress"
                               @click.native="cancel">
                            {{appCommonConstants.CANCEL}}
                        </v-btn>
                        <v-btn class="secondary-blue-btn "
                               flat
                               small
                               id="preview-news-btn"
                               data-qe-id="preview-news-btn"
                               :disabled="!valid || saveInProgress"
                               @click.native="togglePreview">
                            {{appCommonConstants.PREVIEW}}
                        </v-btn>
                        <v-btn color="primary"
                               class="bold-font"
                               small
                               id="save_news_edit"
                               data-qe-id="save_news_edit_btn"
                               :disabled="!valid || saveInProgress"
                               @click.native="submit">
                            {{appCommonConstants.SAVE}}
                        </v-btn>
                    </v-flex>
                </v-layout >
                <image-guidelines v-if="showImageGuidelines" :toggle-show-image-guidelines="toggleShowImageGuidelines"></image-guidelines>
            </v-card>
        </v-form>
        <div v-else class="preview-news">
            <v-btn  flat
                    fab
                    small
                    @click="togglePreview"
                    data-qe-id="preview-news__close-btn"
                    color="ypo_blue"
                    class="preview-news__close">
                <v-icon>fas fa-times</v-icon>
            </v-btn>
            <news-feed :news-feed="newsPreviewData" :preview-mode="true"></news-feed>
        </div>
    </div>
</template>

<script lang="js">

    import { newsFeedConstant, additionalHeadline, additionalLinkText, additionalUrl } from './newsFeed.constant';
    import { appCommonConstants } from "../appCommon.constants";
    import FileUpload from 'vue-upload-component';
    import {imageWithTimeStamp, normalizeUrl, validateEmail, validateUrl } from "@/common/utils/utils";
    import { getUploadedFileBase64, inputFilterForImageFile } from "@/common/utils/fileUploader";
    import { mapActions, mapState } from "vuex";
    import { storeAction } from "@/store/storeActions.constant";
    import StatusBar from "@/components/StatusBar/StatusBar";
    import ImageGuidelines from "./ImageGuidelines";
    import NewsFeed from "@/components/NewsFeed/NewsFeed";

    export default {
        name: 'NewsFeedEditor',
        components: {
            NewsFeed,
            StatusBar,
            FileUpload,
            ImageGuidelines,
        },
        props: {
            newsFeed: {
                type: Object,
                required: true,
            },
            toggleNewsEditor: {
                type: Function,
                required: true,
            },
        },
        created() {
            if (this.newsFeed && this.newsFeed.newsList && this.newsFeed.newsList.length) {
                const mainNews = this.newsFeed.newsList.find(news => news.isPrimary);
                this.primaryNews = mainNews ? {
                    ...mainNews,
                    featuredNewsImage: mainNews.featuredNewsImage && mainNews.featuredNewsImage.url
                        ? {
                        ...mainNews.featuredNewsImage,
                        url: imageWithTimeStamp(mainNews.featuredNewsImage.url),
                    } : {},
                } : null;
                this.newsFeed.newsList.forEach((news) => {
                    if (!news.isPrimary) {
                        this.additionalNewsList.push({
                            ...news,
                            activeLinkType: news.url ? 'url' : 'email',
                        });
                    }
                });
            }
        },
        data() {
            return {
                newsFeedConstant,
                additionalLinkText,
                additionalUrl,
                additionalHeadline,
                appCommonConstants,
                valid: false,
                primaryNews: null,
                previewNews: false,
                newsPreviewData: null,
                additionalNewsList: [],
                showImageGuidelines: false,
                saveInProgress: false,
                files: [],
                imageTypeError: null,
                rules: {
                    headlineRequired: value => !!value || this.newsFeedConstant.errors.HEADLINE_REQUIRED,
                    urlRequired: value => !!value || this.newsFeedConstant.errors.URL_LINK_REQUIRED,
                    emailRequired: value => !!value || this.newsFeedConstant.errors.EMAIL_REQUIRED,
                    urlTextRequired: value => !!value || this.newsFeedConstant.errors.URL_TEXT_REQUIRED,
                    showButton: value => !!value || this.newsFeedConstant.errors.BUTTON_TEXT_REQUIRED,
                    validUrl: v => validateUrl(v) || this.newsFeedConstant.errors.INVALID_URL,
                    validEmail: v => validateEmail(v) || this.newsFeedConstant.errors.INVALID_EMAIL,
                    maxBodyChar: (v) => { return v ? (v.length <= this.newsFeedConstant.const.maxBodyChar || this.newsFeedConstant.errors.MAX_CHAR_LIMIT_EXCEEDED) : true; },
                    maxHeadlineChar: (v) => { return v ? (v.length <= this.newsFeedConstant.const.maxHeadlineChar || this.newsFeedConstant.errors.MAX_CHAR_LIMIT_EXCEEDED) : true; },
                    maxUrlTextChar: (v) => { return v ? (v.length <= this.newsFeedConstant.const.maxUrlTextChar || this.newsFeedConstant.errors.MAX_CHAR_LIMIT_EXCEEDED) : true; },
                    maxButtonChar: (v) => { return v ? (v.length <= this.newsFeedConstant.const.maxButtonChar || this.newsFeedConstant.errors.MAX_CHAR_LIMIT_EXCEEDED) : true; },
                },
            };
        },
        methods: {
            ...mapActions({
                updateNewsFeed: `newsFeed/${storeAction.updateNewsFeed}`,
            }),
            submit() {
                this.saveInProgress = true;
                this.primaryNews = {
                    ...this.primaryNews,
                    url: normalizeUrl(this.primaryNews.url),
                };
                this.additionalNewsList.forEach((news) => {
                    if (news.activeLinkType && news.activeLinkType === 'url') {
                        news.url = normalizeUrl(news.url);
                        news.emailUrl = '';
                    } else {
                        news.url = '';
                    }
                });

                const newsData = [
                    { ...this.primaryNews },
                    ...this.additionalNewsList,
                ];
                this.updateNewsFeed(newsData).then(() => {
                    if (this.toggleNewsEditor) this.toggleNewsEditor();
                });
            },
            cancel() {
                this.primaryNews = null;
                this.additionalNewsList = [];
                if (this.toggleNewsEditor) this.toggleNewsEditor();
            },
            toggleShowImageGuidelines() {
                this.showImageGuidelines = !this.showImageGuidelines;
            },
            inputFilterForImageFile,
            updateUploadedFile() {
                this.imageTypeError = null;
                if (this.files.length) {
                    const { file } = this.files[0];
                    if (file && file.name) {
                        if (file.size > this.newsFeedConstant.const.maxFileSize) {
                            this.imageTypeError = this.newsFeedConstant.errors.FILE_SIZE_ERROR;
                        } else if (!(/\.(jpg|jpeg|png)$/i.test(file.name))) {
                            this.files = [];
                            this.imageTypeError = this.newsFeedConstant.errors.IMAGE_TYPE_NOT_SUPPORTED;
                        } else {
                            getUploadedFileBase64(file).then((customJsonFile) => {
                                //customJsonFile is your newly constructed file.
                                if (customJsonFile) {
                                    this.primaryNews.featuredNewsImage = {
                                        data: customJsonFile.base64StringFile,
                                        contentType: customJsonFile.fileType,
                                        url: this.files[0].url,
                                    };
                                    this.primaryNews.preserveExistngFeaturedNewsImage = false;
                                }
                            });
                        }
                    }
                }
            },
            togglePreview() {
                if (this.valid) {
                    const { primaryNews, additionalNewsList } = this;
                    this.newsPreviewData = {
                        newsList: [
                            { ...primaryNews },
                            ...additionalNewsList,
                        ],
                    };
                    this.previewNews = !this.previewNews;
                }
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            updateNewsAction() {
                return this.actions[storeAction.updateNewsFeed];
            },
        },
    };

</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .editor-form {
        background-color: $white;
        padding-bottom: 20px;
    }

    .news-feed-editor {
        border: 1px solid $ypo-gray;
        border-radius: 4px;

        &__main {
            border-right: 1px solid $ypo-light-medium-gray;

            @include breakpoint(xs) {
                border-bottom: 2px solid $ypo-light-medium-gray;
            }


            &-label {
                font-weight: 600;
                color: $ypo-blue;
                text-align: right;
                margin-top: 2px;
                padding-right: 10px;
                font-size: 13px;

                @include breakpoint(xs) {
                    font-size: 12px;
                }
            }

            &-image--wrapper {
                background-color: $ypo-light-gray;
                height: 132px;
                max-width: 240px;

                @include breakpoint(xs) {
                    max-width: 320px;
                    height: 170px;
                }
            }

            &-image {
                height: inherit;
                width: 100%;
                color: $ypo-error-red;

                &--checkbox {
                    position: absolute !important;
                    bottom: 0;
                    right: 0;
                    padding-left: 10px;

                    @include breakpoint(xs) {
                        position: relative !important;
                        padding: 5px 0 0 0;
                    }
                }
            }
        }

        &__upload-image {
            color: $ypo-blue;
            font-weight: 600;
            font-size: 13px;
            text-transform: capitalize;
            margin-left: 0;
            width: 50%;
        }

        &__guidelines {
            color: $ypo-blue-secondary;
            font-size: 13px;
            font-weight: 600;
            cursor: pointer;
        }

        &__additional {
            &-label {
                font-weight: 600;
                color: $ypo-blue;
                text-align: right;
                margin-top: 4px;
                font-size: 11px;
                padding-right: 7px;
            }

            :nth-child(3n) {
                border: none;
            }
        }

        &__required-msg {
            font-size: 13px;
            text-align: right;
            margin-top: 10px;

            @include breakpoint(xs) {
                text-align: left;
                padding-left: 10px;
            }
        }
    }

    .preview-news {
        position: relative;
        background-color: $ypo-open-blue-gray;
        padding-top: 50px;
        padding-bottom: 10px;
        margin-bottom: 20px;

        @include breakpoint(xs) {
            padding-top: 5px;
        }

        &__close {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
</style>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    .news-feed-editor {

        .v-input {
            margin: 0 !important;

            &__slot {
                min-height: 26px !important;
                height: 26px !important;
                margin-bottom: 2px;
                border-width: 1px !important;
            }

            input {
                margin: 0;
                font-size: 13px;
            }
        }

        .v-counter {
          padding-top: 2px;
        }

        .v-input--checkbox {
            margin-left: -4px !important;
        }

        &__checkbox {
            .v-label {
                font-weight: 500 !important;
                font-size: 12px;
            }
        }

        .additional-news__type {
            .v-btn {
                font-size: 12px;
                height: 20px;
                border: 1px solid $ypo-blue;
                background-color: $white;
                opacity: 1;
                padding-top: 0 !important;
                padding-bottom: 0 !important;

                &--active {
                    background-color: $ypo-blue;
                    .v-btn__content {
                        color: $white;
                    }
                }

                &__content {
                    color: $ypo-cta;
                    text-transform: capitalize !important;
                    font-size: 11px;
                }
            }

            &--email {
                padding-left: 17px;
                padding-right: 17px;
            }
        }

        .v-btn-toggle {
            &--selected {
                box-shadow: none !important;
            }
        }
    }
</style>
